import Vue from 'vue';
import VueRouter from 'vue-router';
// import CheckOut from '@/components/CheckOut.vue'; // 引入支付组件
// import ApplePayTest from '@/components/ApplePayTest.vue'; // 引入支付组件
import ApplePay from '@/components/ApplePay.vue'; // 引入支付组件
import GooglePay from '@/components/GooglePay.vue'; // 引入支付组件
import NewGooglePay from '@/components/NewGooglePay.vue'; // 引入支付组件
import DigitalCash from '@/components/DigitalCash.vue'; // 引入支付组件
import CodaPay from '@/components/CodaPay.vue'; // 引入支付组件
import AdyenPay from '@/components/AdyenPay.vue'; // 引入支付组件
import AdApplePay from '@/components/AdApplePay.vue'; // 引入支付组件
import AdCardPay from '@/components/AdCardPay.vue'; // 引入支付组件
import AdGooglePay from '@/components/AdGooglePay.vue'; // 引入支付组件
import AdCashApp from '@/components/AdCashApp.vue'; // 引入支付组件
import AdyApplePay from '@/components/AdyApplePay.vue'; // 引入支付组件
import AdyGooglePay from '@/components/AdyGooglePay.vue'; // 引入支付组件
import AdyCashApp from '@/components/AdyCashApp.vue'; // 引入支付组件
import SuCashApp from '@/components/SuCashApp.vue'; // 引入支付组件
Vue.use(VueRouter);

const routes = [
    // {
    //     path: '/checkout/:encryptedString',
    //     name: 'CheckOut',
    //     component: CheckOut,  // 绑定 CheckOut 组件
    // },
    // {
    //     path: '/applepaytest/:encryptedString',
    //     name: 'ApplePayTest',
    //     component: ApplePayTest,  // 绑定 CheckOut 组件
    // },
    {
        path: '/applepay/:encryptedString',
        name: 'ApplePay',
        component: ApplePay,  // 绑定 CheckOut 组件
    },
    {
        path: '/googlepay/:encryptedString',
        name: 'GooglePay',
        component: GooglePay,  // 绑定 CheckOut 组件
    },
    {
        path: '/newgooglepay/:encryptedString',
        name: 'NewGooglePay',
        component: NewGooglePay,  // 绑定 CheckOut 组件
    },
    {
        path: '/digitalcash/:encryptedString',
        name: 'DigitalCash',
        component: DigitalCash,  // 绑定 CheckOut 组件
    },
    {
        path: '/coda/:encryptedString',
        name: 'CodaPay',
        component: CodaPay,  // 绑定 CheckOut 组件
    },
    {
        path: '/adpay/:encryptedString',
        name: 'AdyenPay',
        component: AdyenPay,  // 绑定 CheckOut 组件
    },
    {
        path: '/adapplepay/:encryptedString',
        name: 'AdApplePay',
        component: AdApplePay,  // 绑定 CheckOut 组件
    },
    {
        path: '/adcardpay/:encryptedString',
        name: 'AdCardPay',
        component: AdCardPay,  // 绑定 CheckOut 组件
    },
    {
        path: '/adycardpay/:encryptedString',
        name: 'AdCardPay',
        component: AdCardPay,  // 绑定 CheckOut 组件
    },
    {
        path: '/adgoogle/:encryptedString',
        name: 'AdGooglePay',
        component: AdGooglePay,  // 绑定 CheckOut 组件
    },
    {
        path: '/adcashapp/:encryptedString',
        name: 'AdCashApp',
        component: AdCashApp,  // 绑定 CheckOut 组件
    },
     {
        path: '/adyapplepay/:encryptedString',
        name: 'AdyApplePay',
        component: AdyApplePay,  // 绑定 CheckOut 组件
    },
    {
        path: '/adygoogle/:encryptedString',
        name: 'AdyGooglePay',
        component: AdyGooglePay,  // 绑定 CheckOut 组件
    },
    {
        path: '/adycashapp/:encryptedString',
        name: 'AdyCashApp',
        component: AdyCashApp,  // 绑定 CheckOut 组件
    },
    {
        path: '/sucash/:encryptedString',
        name: 'SuCashApp',
        component: SuCashApp,  // 绑定 CheckOut 组件
    },      
    // 其他路由...
];

const router = new VueRouter({
    mode: 'history',
    routes
});

// 全局路由守卫设置默认标题
router.beforeEach((to, from, next) => {
    // 如果有指定 title 就使用，没有就设置默认值
    document.title = to.meta.title || 'title';
    next();
});

export default router;
